module.exports = __webpack_public_path__ + "static/media/PA.0b468e39.svg";